<template><other-stock-document-page direction="out" /></template>
<script>
import OtherStockDocumentPage from '../components/OtherStockDocumentPage'
export default { name: 'ErpOtherStockOut', components: { OtherStockDocumentPage } }
</script>
